var _circle, _mask, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 7,
    width: 10,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3504 7H20.6478V16.134H11.3504V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0445 12.8134C12.6153 14.716 14.4105 16.0892 15.979 16.1332H15.9934V16.134C15.9951 16.1332 15.9968 16.1332 15.9993 16.1332C16.001 16.1332 16.0027 16.1332 16.0052 16.134V16.1332H16.0188C17.5873 16.0892 19.3825 14.716 19.9542 12.8134C20.2095 12.8007 20.4877 12.4295 20.6002 11.9289C20.7228 11.3818 20.6002 10.8879 20.3262 10.8271C20.2501 10.8093 20.1698 10.8296 20.0912 10.877C19.791 8.68179 18.082 6.99991 16.0188 6.99991C16.012 6.99991 16.0061 6.99991 15.9993 6.99991C15.9926 6.99991 15.9858 6.99991 15.979 6.99991C13.9158 6.99991 12.2068 8.68179 11.9067 10.877C11.8289 10.8296 11.7485 10.8093 11.6716 10.8271C11.3976 10.8879 11.2758 11.3818 11.3976 11.9289C11.5101 12.4295 11.7883 12.8007 12.0445 12.8134Z",
    fill: "#789BE7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9873 22.4014C22.6253 20.0854 21.1151 18.149 19.0552 17.1858C18.4591 17.8623 17.3565 18.3172 16.0923 18.3172C16.0635 18.3172 16.0348 18.3155 16.006 18.3155V18.3147H16.0001H15.9942V18.3155C15.9654 18.3155 15.9367 18.3172 15.9079 18.3172C14.6429 18.3172 13.5411 17.8623 12.945 17.1858C10.8851 18.149 9.37489 20.0854 9.01298 22.4014C8.93011 22.9274 9.25144 23.4322 9.76725 23.6343C11.5963 24.3548 13.7229 24.7683 15.9942 24.77H16.0001H16.006C18.2773 24.7683 20.404 24.3548 22.233 23.6343C22.748 23.4322 23.0693 22.9274 22.9873 22.4014Z",
    fill: "#789BE7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/noAvatar.09d692d0409d6258f909b065fe8a0fba.svg";
export { ForwardRef as ReactComponent };